import React, { useState, useEffect } from 'react';
import Components from './components/Components';
import ScrolToTop from './components/Elements/ScrolToTop';
import Loader from "./components/Elements/Loader";

const App = () => {
  // State to manage loader visibility
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Simulate a loading process, you can tie this to actual data fetching
    const timer = setTimeout(() => {
      setLoading(false); // Hide loader after time out or data is loaded
    }, 3000); // 3000 ms = 3 seconds

    return () => clearTimeout(timer); // Cleanup the timer
  }, []);

  return (
    <div className="App">
      <Components />  
      <ScrolToTop/>
      {loading ? <Loader/> : null}  
    </div>
  );
}

export default App;